export default {
    manage_deleteAssetSubtype_title: "Eliminar Subtipo de Activo",
    manage_deleteAssetSubtypes_title: "Eliminar Subtipos de Activo",
    manage_deleteAssetSubtypes_description: "¿Estás seguro de que deseas eliminar estos subtipos de activo?",
    manage_deleteAssetSubtype_description: "¿Estás seguro de que deseas eliminar este subtipo de activo?",
    manage_deleteAssetSubtype_successMessage: "Subtipo de Activo Eliminado",
    manage_deleteAssetSubtypes_successMessage: "Subtipos de Activo Eliminados",
    manage_deleteAssetSubtypes_are_in_use: "No es posible eliminar subtipos de activo en uso",
    manage_deleteAssetSubtypes_successMessageUpdate: "Subtipos de activos eliminados con éxito",
    manage_deleteAssetSubtype_successMessageUpdate: "Subtipo de activo eliminado con éxito",
}